import { ITheme } from "../../utils/theme";

export const linkStyle = (theme: ITheme) => ({
  mb: 2,
  '&:last-of-type': {
    mb: 0
  }
})

export const textStyle = {
  textAlign: "center",
  mb: 2
}